export default [
  {
    path: 'category',
    name: 'category',
    component: () => import('./views/CategoryView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Categorías' 
    },
  }
]